import React, { PureComponent } from 'react';
import cn from 'classnames';
import { WIDTHS as AVAILABLE_BUTTON_WIDTHS } from '@alfa-bank/site-button/src/config';

import type { IProps } from './models';

export class ResultsCardContent extends PureComponent<IProps> {
    renderButtonBlock = () => {
        const {
            Button,
            Grid,
            advCodes = [],
            buttonId,
            buttonKind = 'red',
            buttonSize,
            buttonText = 'Заполнить заявку',
            buttonTheme = 'white',
            buttonWidth,
            classNames = {},
            onClick,
            openPageInNewWindow,
            url = '',
            isMobile,
        } = this.props;

        const computedButtonWidth = buttonWidth || (isMobile ? 'full' : 'auto');
        const computedButtonSize = buttonSize || (isMobile ? 'm' : 'l');

        const isAvailableButtonWidth = AVAILABLE_BUTTON_WIDTHS.includes(computedButtonWidth || '');

        const buttonElement = (
            <Button
                advCodes={advCodes}
                buttonSize={computedButtonSize}
                buttonText={buttonText}
                buttonWidth={isAvailableButtonWidth ? computedButtonWidth : 'full'}
                classNames={{
                    containerMargin: cn(classNames.external, classNames.containerMargin),
                }}
                id={buttonId}
                kind={buttonKind}
                onClick={onClick}
                openPageInNewWindow={openPageInNewWindow}
                theme={buttonTheme}
                url={url}
            />
        );

        if (isAvailableButtonWidth) {
            return buttonElement;
        }

        return (
            <Grid columnsWidth={computedButtonWidth} justify="start">
                {buttonElement}
            </Grid>
        );
    };

    render() {
        const { Text, children, classNames = {}, showButton = true, styles, title } = this.props;

        return (
            <>
                {title && (
                    // ToDo: Артемьев Федор, поправить добавление стилей (попробовать &)
                    <Text
                        className={cn(styles.external, styles.resultsHeader, {
                            [classNames.resultsHeaderMargin]: classNames.resultsHeaderMargin,
                            [styles.resultsHeaderMargin]: !classNames.resultsHeaderMargin,
                        })}
                        kind="subtitle"
                        size="l"
                        theme="white"
                    >
                        {title}
                    </Text>
                )}
                <div
                    className={cn(styles.resultsContainer, {
                        [classNames.resultsContainer]: classNames.resultsContainer,
                    })}
                >
                    {children}
                </div>
                {showButton && this.renderButtonBlock()}
            </>
        );
    }
}
